<template>
  <v-card elevation="0" width="100%">
    <v-dialog v-model="dialog" max-width="500">
      <Confirm
          title="Salvar"
          message="Tem certeza de que deseja salvar estes dados?"
          buttonText="Salvar"
          @cancel="dialog = false"
          @action="submit"
      />
    </v-dialog>

    <v-form ref="discountApplicators">
      <v-row cols="12" sm="12" md="12" lg="12" class="ma-0">
        <v-col cols="12" sm="12" md="12" lg="12">
          <label class="ml-1 mb-2 label-details">Desconto para aplicadores</label>
          <vuetify-money
              color="black"
              v-bind:outlined="outlined"
              background-color="#F5F5F5"
              placeholder="0,00"
              :rules="[rules.required]"
              required
              hide-details
              style="border: 1px solid #979797; border-radius: 7.5px"
              v-model="platformSettings.percentageDiscountForApplicators"
              v-bind:options="optionsPercentagem"
          ></vuetify-money>
        </v-col>
      </v-row>

      <v-row class="pb-3" justify="center">
        <v-col cols="12" md="6">
          <v-btn
              class="primary-button"
              color="normalred"
              elevation="0"
              @click="validate()"
              block
          >
            Salvar
          </v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Vue from "vue";
import Confirm from "../../components/ConfirmExit.vue";
import {VMoney} from "v-money";

export default {
  name: "DiscountApplicators",
  components: {
    Confirm,
  },
  props: {},
  data: () => ({
    outlined: true,
    optionsPercentagem: {
      locale: "pt-BR",
      suffix: "",
      prefix: "%",
      length: 11,
      precision: 2,
      min: 10,
      max: 10
    },
    apiService: new ApiService(),
    dialog: false,
    platformSettings: {
      id: null,
      percentageDiscountForApplicators: 0
    },
    rules: {
      required: (value) => !!value || "Campo requerido.",
    },
  }),
  async created() {
    await this.getPlatformSettings();
  },
  methods: {
    async getPlatformSettings() {
      try {
        await this.apiService.get("platformsettings/get").then((response) => {
          if (response.body !== "") {
            this.platformSettings = response
          }
        });
      } catch (e) {
      }
    },
    validate() {
      if (!this.$refs.discountApplicators.validate()) {
        Vue.$globalEvent.$emit("onFlashMessage", {
          type: "error",
          title: "",
          message: "Digite o valor do frete padrão das revendas",
          trace: null,
        });
        return
      }
      this.dialog = true;
    },
    async submit() {
      try {
        let urlMethod = "editPercentageDiscountApplicators"
        let httpMethod = 'put'
        if (!this.platformSettings.id) {
          urlMethod = 'add'
          httpMethod = 'post'
          delete this.platformSettings.id
        }
        this.apiService[httpMethod](`platformsettings/${urlMethod}`, this.platformSettings)
            .then(async (resp) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "success",
                title: "",
                message: resp.message,
                trace: null,
              });
              await this.getPlatformSettings()
              this.dialog = false;
              this.loading = false;
            })
            .catch((err) => {
              Vue.$globalEvent.$emit("onFlashMessage", {
                type: "error",
                title: "Erro",
                message: err.body.message,
                trace: null,
              });
              this.dialog = false;
              this.loading = false;
            });
      } catch (e) {

      }
    },
  },
};
</script>
<style scoped>
</style>
